import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import { Button, Checkbox, FormControlLabel, IconButton, InputAdornment, Popover, TableSortLabel, TextField, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { ArrowDownward } from "@mui/icons-material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { Loader } from "@egovernments/digit-ui-react-components";
import dayjs from "dayjs";

import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

const ApplicationTable = ({
  dashboardData,
  filters,
  showMs,
  setshowMs,
  onApplicationSelect,
  fastPasIdSearch,
  setFastPasIdSearch,
  loading,
  isFromProgress = false,
}) => {
  const history = useHistory();
  const [orderBy, setOrderBy] = useState("createdTime");
  const [order, setOrder] = useState("desc");
  const [globalSearch, setGlobalSearch] = useState("");
  const [page, setPage] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [selectedColumns, setSelectedColumns] = useState([
    "srNo",
    "applicationNo",
    "applicationType",
    "organization",
    "createdUserName",
    ...(isFromProgress ? ["daysPending"] : []),
    "status",
  ]);
  const [columnFilters, setColumnFilters] = useState({});

  console.log("IsLoadingComing", loading);
  // ✅ Handle Take Action - Navigate based on business service
  const handleTakeAction = (item) => {
    console.log("itemFromTakeAction", item, item?.businessService);

    const sourceQuery = "?source=dashboard";

    switch (item?.businessService) {
      case "BPAREG":
        Digit.SessionStorage.del("EMP_LTP");
        Digit?.SessionStorage.del("isDocValidated");
        Digit?.SessionStorage.del("isNotingValidated");
        if (onApplicationSelect) {
          Digit.SessionStorage.set("DASHBOARD_ID", item?.applicationNo);
          onApplicationSelect(item);
        }
        // history.push(`/digit-ui/employee/obps/professional/${item?.applicationNo}${sourceQuery}`);
        break;

      case "BPA_MAPSUB_DA":
      case "BPA_MAPSUB_AVP":
      case "BPA_MAPPLINTH_DA":
      case "BPA_PURCHASEFAR_DA":
        Digit.SessionStorage.del("EMP_MAPSUB");
        Digit?.SessionStorage.del("isDocValidated");
        Digit?.SessionStorage.del("isNotingValidated");
        if (onApplicationSelect) {
          Digit.SessionStorage.set("DASHBOARD_ID", item?.applicationNo);
          onApplicationSelect(item);
        }
        // history.push(`/digit-ui/employee/obps/application/MAP_SUB/${item?.applicationNo}${sourceQuery}`);
        break;

      case "BPA_FAR_DA":
      case "BPA_FAR_AVP":
        if (onApplicationSelect) {
          Digit.SessionStorage.set("DASHBOARD_ID", item?.applicationNo);
          onApplicationSelect(item);
        }
        // history.push(`/digit-ui/employee/obps/application/PURCHASABLE_FAR/${item?.applicationNo}${sourceQuery}`);
        break;

      case "BPA_LANDUSE_DA":
      case "BPA_LANDUSE_AVP":
      case "BPA_KYP_DA":
        Digit.SessionStorage.del("EMP_LANDUSE");
        Digit?.SessionStorage.del("isDocValidated");
        Digit?.SessionStorage.del("isNotingValidated");
        if (onApplicationSelect) {
          Digit.SessionStorage.set("DASHBOARD_ID", item?.applicationNo);
          onApplicationSelect(item);
        }
        break;

      default:
        if (item?.businessService?.startsWith("BPA_NOC")) {
          if (onApplicationSelect) {
            Digit.SessionStorage.set("DASHBOARD_ID", item?.applicationNo);
            onApplicationSelect(item);
          }
          // history.push(`/digit-ui/employee/obps/application/NOC/${item?.applicationNo}${sourceQuery}`);
        } else {
          console.log("Unhandled Business Service", item?.businessService);
        }
    }
  };
  // ✅ All available columns definition
  const ALL_COLUMNS = [
    { id: "srNo", label: "Sr. No.", filterable: false, sortable: false },
    {
      id: "applicationNo",
      label: "Application No.",
      filterable: true,
      sortable: true,
      exportValue: (item) => item?.applicationNo || "-",
      render: (item, onTakeAction) => (
        <a onClick={() => handleTakeAction(item)} style={{ cursor: "pointer" }}>
          {item?.applicationNo || "-"}
        </a>
      ),
    },
    { id: "applicationType", label: "Application Type", filterable: true, sortable: true, render: (item) => item?.applicationType || "-" },
    {
      id: "organization",
      label: "Organization",
      filterable: true,
      sortable: true,
      render: (item) => `${item?.shortName} - ${item?.location1}` || item?.department || "-",
    },
    { id: "riskType", label: "Risk Type", filterable: true, sortable: true, render: (item) => item?.riskType || "-" },
    { id: "createdUserName", label: "Created By", filterable: true, sortable: true, render: (item) => item?.createdUserName || "-" },
    // {
    //   id: "lastUserDesignation",
    //   label: "Created Designation",
    //   filterable: true,
    //   sortable: true,
    //   render: (item) => item?.createdUserDesignation || "-",
    // },
    { id: "createdTime", label: "Created On", filterable: false, sortable: true, render: (item) => item?.createdTime || "-" },
    // { id: "lastCreatedTime", label: "Updated By", filterable: false, sortable: true, render: (item) => item?.lastCreatedTime || "-" },
    ...(isFromProgress
      ? [
          {
            id: "daysPending",
            label: "Days Pending",
            filterable: false,
            sortable: true,
            render: (item) => {
              if (!item?.lastCreatedTime) return "-";

              const diff = dayjs().startOf("day").diff(dayjs(item.lastCreatedTime, "DD-MM-YYYY"), "day");

              return diff;
            },
          },
        ]
      : []),
    { id: "updatedOn", label: "Updated On", filterable: false, sortable: true, render: (item) => item?.lastCreatedTime || "-" },
    {
      id: "status",
      label: "Status",
      filterable: true,
      sortable: true,
      render: (item) => (item?.subDashBoardStatus === "Pending for DSC" ? item?.subDashBoardStatus : item?.status || "-"),
    },
    // { id: "subDashBoardStatus", label: "Sub Status", filterable: true, sortable: true, render: (item) => item?.subDashBoardStatus || "-" },
  ];

  const getPendingDays = (dateStr) => {
    if (!dateStr) return -1;

    const [day, month, year] = dateStr.split("-").map(Number);
    const date = new Date(year, month - 1, day);

    if (isNaN(date.getTime())) return -1;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);

    return Math.floor((today - date) / (1000 * 60 * 60 * 24));
  };

  // ✅ Column comparator for sorting
  const getComparator = (order, orderBy) => {
    return (a, b) => {
      let aValue;
      let bValue;

      if (orderBy === "daysPending") {
        aValue = getPendingDays(a.lastCreatedTime);
        bValue = getPendingDays(b.lastCreatedTime);
      } else {
        aValue = a[orderBy] ? a[orderBy].toString().toLowerCase() : "";
        bValue = b[orderBy] ? b[orderBy].toString().toLowerCase() : "";
      }

      if (order === "desc") {
        return bValue > aValue ? 1 : bValue < aValue ? -1 : 0;
      }

      return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
    };
  };

  // ✅ Handle sorting
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // ✅ Handle column filter change
  const handleColumnFilterChange = (property, value) => {
    setColumnFilters({
      ...columnFilters,
      [property]: value,
    });
    setPage(0);
  };

  // ✅ Handle clear column filter
  const handleClearColumnFilter = (property) => {
    setColumnFilters({
      ...columnFilters,
      [property]: "",
    });
  };

  // ✅ Handle global search
  const handleGlobalSearch = (value) => {
    setGlobalSearch(value);
    setPage(0);
  };

  const handleFasPassIdSearch = (value) => {
    setFastPasIdSearch(value);
    setPage(0);
  };

  // ✅ String matching helper
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };

  // Apply prop-based filters - CORRECTED
  const getFilteredData = () => {
    let filteredData = dashboardData || [];

    filteredData = filteredData.filter((app) => {
      const status = app.status?.toString().toLowerCase() || "";
      const mainStatus = app.mainDashBoardStatus?.toString().toLowerCase() || "";
      const newSubStatus = app?.subDashBoardStatus?.toLowerCase();
      const filterStatus = filters?.status?.toString() || "";

      let matchesStatus = !filterStatus ? true : false;

      if (filterStatus) {
        if (filterStatus === "Rejected") {
          matchesStatus = status.includes("reject") || mainStatus.includes("reject");
        } else if (filterStatus === "Send back to Applicant") {
          // Shortfall: revert to applicant, send back to applicant
          matchesStatus =
            status.includes("revert to applicant") ||
            status.includes("send back to applicant") ||
            status.includes("shortfall") ||
            mainStatus.includes("send back") ||
            mainStatus.includes("shortfall") ||
            mainStatus === "citizen_action_pending_at_ltp";
        } else if (filterStatus === "Document Uploaded") {
          // Draft Files: only "Document Uploaded" status
          matchesStatus = status.includes("document uploaded");
        } else if (filterStatus === "Approved") {
          // Approved Files: Approved or Approve in mainDashBoardStatus (but NOT Apply For DSC)
          matchesStatus = (mainStatus.includes("approved") || mainStatus.includes("approve")) && !status.includes("apply for dsc");
        } else if (filterStatus === "Make Payment") {
          // Payment Pending: Make Payment, Pay Application Fees, Make Payment Self
          matchesStatus = status.includes("make payment") || status.includes("pay application fees") || status.includes("make payment self");
        } else if (filterStatus === "Apply For DSC") {
          // DSC Pending: Apply For DSC
          matchesStatus =
            status.includes("apply for dsc") ||
            status.startsWith("APPLY_FOR_DSC") ||
            newSubStatus === "pending for dsc" ||
            mainStatus.startsWith("APPLY_FOR_DSC") ||
            newSubStatus === "pending for dsc";
        } else {
          matchesStatus = app.mainDashBoardStatus === filterStatus;
        }
      }

      return matchesStatus;
      //  &&
      // // ⭐ RISK FILTER FIX
      // (!filters?.riskType || app.riskType === filters.riskType || (filters.riskType === "HIGH" && app.riskType === "HIGH_NIVESH")) &&
      // (!filters?.applicationType || app.applicationType === filters.applicationType) &&
      // (!filters?.createdBy || app.createdUserName === filters.createdBy) &&
      // (!filters?.department || app.department === filters.department)
    });

    if (globalSearch) {
      filteredData = filteredData.filter((item) => {
        return ALL_COLUMNS.some((col) => matchesSearch(item[col.id], globalSearch));
      });
    }

    Object.entries(columnFilters).forEach(([key, value]) => {
      if (value) {
        filteredData = filteredData.filter((item) => matchesSearch(item[key], value));
      }
    });

    return filteredData;
  };

  // ✅ Get visible columns
  const visibleColumns = ALL_COLUMNS.filter((col) => selectedColumns.includes(col.id));

  // ✅ Apply filtering and sorting
  const filteredData = getFilteredData();
  const sortedData = filteredData.slice().sort(getComparator(order, orderBy));
  const paginatedData = sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  // ✅ Handle column selection
  const handleColumnToggle = (columnId) => {
    if (selectedColumns.includes(columnId)) {
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter((id) => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };

  // ✅ Handle select all columns
  const handleSelectAllColumns = (e) => {
    if (e.target.checked) {
      setSelectedColumns(ALL_COLUMNS.map((col) => col.id));
    } else {
      setSelectedColumns(["srNo"]);
    }
  };

  // ✅ Handle pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // ✅ Column filter popup handlers
  const handleOpenColumnFilter = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseColumnFilter = () => {
    setAnchorEl(null);
  };

  // ✅ Excel download handler
  const handleExcelDownload = () => {
    // Export filtered items with ALL columns
    const exportData = filteredData.map((app, idx) => {
      const row = {};
      ALL_COLUMNS.forEach((col) => {
        if (col.id === "srNo") {
          row[col.label] = idx + 1;
        } else if (typeof col.exportValue === "function") {
          row[col.label] = col.exportValue(app);
        } else if (typeof col.render === "function") {
          row[col.label] = col.render(app);
        } else {
          row[col.label] = app[col.id] ? app[col.id] : "-";
        }
      });
      return row;
    });

    Digit.Download.Excel(exportData, "application-details");
  };

  return (
    <React.Fragment>
      <TableContainer className="table-container">
        <div>
          <caption className="emp-table-caption">Application Details Summary</caption>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Button
              variant="outlined"
              startIcon={<FilterListIcon />}
              onClick={handleOpenColumnFilter}
              size="small"
              sx={{
                height: "27px",
                fontSize: "12px",
                borderColor: "rgb(31, 74, 124)",
                color: "rgb(31, 74, 124)",
              }}
            >
              Columns ({selectedColumns.length}/{ALL_COLUMNS.length})
            </Button>
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search By FastPas Id"
              value={fastPasIdSearch}
              onChange={(e) => handleFasPassIdSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ background: "#2A3F54", color: "#fff", height: "24px", borderRadius: "7px 0px 0px 7px", width: "32px" }} />
                  </InputAdornment>
                ),
                endAdornment: fastPasIdSearch && (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => handleFasPassIdSearch("")}>
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                padding: "0px",
                height: "25px",
                "& .MuiInputBase-root": {
                  height: "27px",
                  padding: "0px",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgb(31, 74, 124)",
                },
                "& .MuiOutlinedInput-input": {
                  padding: "0",
                  fontSize: "12px",
                },
              }}
            />
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search here..."
              value={globalSearch}
              onChange={(e) => handleGlobalSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ background: "#2A3F54", color: "#fff", height: "24px", borderRadius: "7px 0px 0px 7px", width: "29px" }} />
                  </InputAdornment>
                ),
                endAdornment: globalSearch && (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => handleGlobalSearch("")}>
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                padding: "0px",
                height: "25px",
                "& .MuiInputBase-root": {
                  height: "27px",
                  padding: "0px",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgb(31, 74, 124)",
                },
                "& .MuiOutlinedInput-input": {
                  padding: "0",
                  fontSize: "12px",
                },
              }}
            />
            <Button
              variant="outlined"
              color="primary"
              onClick={handleExcelDownload}
              size="small"
              sx={{
                height: "27px",
                fontSize: "12px",
              }}
              disabled={filteredData.length === 0}
            >
              Download Excel
            </Button>
          </div>
        </div>

        {/* Column Filter Popover */}
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleCloseColumnFilter}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <div className="select-column-popover">
            <Typography variant="subtitle2" gutterBottom>
              Select Columns to Display
            </Typography>
            <FormControlLabel
              control={
                <Checkbox
                  sx={{ padding: "0px" }}
                  checked={selectedColumns.length === ALL_COLUMNS.length}
                  indeterminate={selectedColumns.length > 0 && selectedColumns.length < ALL_COLUMNS.length}
                  onChange={handleSelectAllColumns}
                />
              }
              sx={{ margin: "0px", fontWeight: "bold" }}
              label="Select All"
            />
            {ALL_COLUMNS.map((column) => (
              <div key={column.id}>
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{ padding: "0px" }}
                      checked={selectedColumns.includes(column.id)}
                      onChange={() => handleColumnToggle(column.id)}
                      disabled={column.id === "srNo"}
                    />
                  }
                  sx={{ margin: "0px" }}
                  label={column.label}
                />
              </div>
            ))}
          </div>
        </Popover>

        {/* Table */}
        {loading ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Loader />
          </div>
        ) : (
          <Table stickyHeader className="application-table">
            <thead>
              <tr>
                {visibleColumns.map((column) => (
                  <th key={column.id}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span>{column.label}</span>
                      {column.sortable && (
                        <TableSortLabel
                          active={orderBy === column.id}
                          direction={orderBy === column.id ? order : "asc"}
                          onClick={() => handleSort(column.id)}
                          sx={{
                            color: "white !important",
                            "& .MuiTableSortLabel-icon": {
                              opacity: "1 !important",
                              color: "white !important",
                            },
                            "&:hover": {
                              color: "white !important",
                            },
                          }}
                          IconComponent={(props) => (
                            <ArrowDownward
                              {...props}
                              sx={{
                                color: "white !important",
                                opacity: 1,
                                fontSize: "16px",
                              }}
                            />
                          )}
                        />
                      )}
                    </div>
                  </th>
                ))}
              </tr>
              <tr>
                {visibleColumns.map((column) => (
                  <td key={column.id}>
                    {column.filterable && (
                      <TextField
                        variant="standard"
                        size="small"
                        value={columnFilters[column.id] || ""}
                        onChange={(e) => handleColumnFilterChange(column.id, e.target.value)}
                        InputProps={{
                          endAdornment: columnFilters[column.id] && (
                            <InputAdornment position="end">
                              <IconButton size="small" onClick={() => handleClearColumnFilter(column.id)} sx={{ color: "white" }}>
                                <ClearIcon fontSize="small" />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          "& .MuiInput-input": {
                            color: "black !important",
                            fontSize: "0.75rem",
                          },
                          width: "100%",
                        }}
                      />
                    )}
                  </td>
                ))}
              </tr>
            </thead>
            <tbody>
              {paginatedData.length === 0 ? (
                <tr>
                  <td colSpan={visibleColumns.length} align="center" style={{ padding: "20px" }}>
                    No records found
                  </td>
                </tr>
              ) : (
                paginatedData.map((item, index) => (
                  <tr key={index}>
                    {visibleColumns.map((column) => (
                      <td key={`${index}-${column.id}`}>{column.id === "srNo" ? page * rowsPerPage + index + 1 : column.render(item)}</td>
                    ))}
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        )}
      </TableContainer>

      {/* Pagination */}
      {!loading && (
        <TablePagination
          component="div"
          count={filteredData.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[10, 20, 30, 50, 100]}
        />
      )}
    </React.Fragment>
  );
};

export default ApplicationTable;
